// const pavilion = {
//   siteName: "pavilion",
//   isPaymentShow: true,
//   isLoginShow: false,
//   isDineOption: true,
//   EmptyImage: "empty_cart",
//   star: "star",
//   chef: "chef",
//   empty: "empty",
//   clock: "clock",
//   payment: "payment",
//   apple: "apple",
//   google: "google",
//   flower: "flower",
//   search: "search",
//   qr_code_error: "qr_code_error",
//   order_mode: "PayFirst",
//   qr_type: "Static",
//   register_no: "POS01",
//   home_banner_enable: false,
//   serviceMode: "DineInAndTakeAway", // DineInOnly, TakeAwayOnly, DineInAndTakeAway
// };

// const gochiso = {
//   siteName: "Gochiso",
//   isPaymentShow: false,
//   isLoginShow: false,
//   isDineOption: true,
//   EmptyImage: "empty_cart",
//   star: "star",
//   chef: "chef",
//   empty: "empty",
//   clock: "clock",
//   payment: "payment",
//   apple: "apple",
//   google: "google",
//   flower: "flower",
//   search: "search",
//   qr_code_error: "qr_code_error",
//   order_mode: "PayAtCounter",
//   qr_type: "Dynamic",
//   register_no: "POS01",
//   home_banner_enable: false,
//   serviceMode: "DineInOnly", // DineInOnly, TakeAwayOnly, DineInAndTakeAway
// };
// const butakizoku = {
//   siteName: "butakizoku",
//   isPaymentShow: false,
//   isLoginShow: false,
//   isDineOption: false,
//   EmptyImage: "empty_cart",
//   star: "star",
//   chef: "chef",
//   empty: "empty",
//   clock: "clock",
//   payment: "payment",
//   apple: "apple",
//   google: "google",
//   flower: "flower",
//   search: "search",
//   qr_code_error: "qr_code_error",
//   order_mode: "PayAtCounter",
//   qr_type: "Dynamic",
//   register_no: "POS01",
//   home_banner_enable: false,
//   serviceMode: "DineInOnly", // DineInOnly, TakeAwayOnly, DineInAndTakeAway
// };

const siteDetails = {
  pavilion: {
    siteName: "pavilion",
    isPaymentShow: true,
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayFirst",
    qr_type: "Static",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "DineInAndTakeAway",
  },
  gochiso: {
    siteName: "Gochiso",
    paymentMode: ["Counter", "Online"],
    isPaymentShow: false,
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayAtCounter",
    qr_type: "Dynamic",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "DineInOnly",
  },
  butakizoku: {
    siteName: "butakizoku",
    isPaymentShow: false,
    isLoginShow: false,
    isDineOption: false,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayAtCounter",
    qr_type: "Dynamic",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "DineInOnly",
  },
  whitetiffin: {
    siteName: "whitetiffin",
    paymentMode: ["Counter", "Online", "QlubQR"],
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayFirst",
    qr_type: "Static",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "TakeAwayOnly",
  },
  mannabistro: {
    siteName: "mannabistro",
    isPaymentShow: true,
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayFirst",
    qr_type: "Static",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "DineInAndTakeAway",
  },
  oldteahut: {
    siteName: "oldteahut",
    paymentMode: ["Counter", "Online"],
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayFirst",
    qr_type: "Static",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "TakeAwayOnly",
    taxValue: 8,
    gstInclusive: false,
    enableServiceCharge: false,
    enableGST: false,
    enableRemarks: true,
    enablePreOrder: true,
  },
  yeamamacafe: {
    siteName: "yeamamacafe",
    paymentMode: ["Online"],
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayFirst",
    qr_type: "Static",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "DineInAndTakeAway",
    taxValue: 8,
    gstInclusive: true,
    enableServiceCharge: false,
    enableGST: true,
    enablePreOrder: false,
  },
  design1: {
    siteName: "oldteahut",
    paymentMode: ["Counter", "Online"],
    isLoginShow: false,
    isDineOption: true,
    EmptyImage: "empty_cart",
    star: "star",
    chef: "chef",
    empty: "empty",
    clock: "clock",
    payment: "payment",
    apple: "apple",
    google: "google",
    flower: "flower",
    search: "search",
    qr_code_error: "qr_code_error",
    order_mode: "PayFirst",
    qr_type: "Static",
    register_no: "POS01",
    home_banner_enable: false,
    serviceMode: "TakeAwayOnly",
    taxValue: 8,
    gstInclusive: false,
    enableServiceCharge: false,
    enableGST: false,
    enableRemarks: true,
    enablePreOrder: true,
  },
};
const config = siteDetails[process.env.REACT_APP_MODE];

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...config,
};
